export default __webpack_public_path__ + "static/media/arisan_earth.bf808190.svg";